const langAdminNavigation = {
	investor_list: {
		tag: 'admin.navigation.investor_list',
		fr: 'Liste des investisseurs',
		en: 'Investor list',
	},
	document_access: {
		tag: 'admin.navigation.document_access',
		fr: 'Téléchargement de docs',
		en: 'Document access',
	},
	document_access_logs: {
		tag: 'admin.navigation.document_access_logs',
		fr: 'Logs accès documents',
		en: 'Document access logs',
	},
	admin_document_access_capital_calls: {
		tag: 'admin.navigation.admin_document_access_capital_calls',
		fr: 'Téléchargement appels de fonds',
		en: 'Download capitals calls',
	},
	admin_email_notifications: {
		tag: 'admin.navigation.admin_email_notifications',
		fr: 'Notifications e-mails',
		en: 'Emails notifications',
	},
	admin_email_notifications_list: {
		tag: 'admin.navigation.admin_email_notifications_list',
		fr: 'Liste des notifications',
		en: 'Notifications list',
	},
	admin_document_email_notifications: {
		tag: 'admin.navigation.admin_document_email_notifications',
		fr: 'Stats par document',
		en: 'Stats by document',
	},
	admin_user_email_notifications: {
		tag: 'admin.navigation.admin_user_email_notifications',
		fr: 'Stats par contact',
		en: 'Stats by contact',
	},
	admin_notification_monitoring: {
		tag: 'admin.navigation.admin_notification_monitoring',
		fr: 'Suivi des envois',
		en: 'Sending monitoring',
	},
};

export default langAdminNavigation;
